import { useQuery } from 'react-query';
import { useAuthorizedClient } from '../contexts/Auth';

function usePurchases({
  limit = 6,
  cursor,
}: {
  limit?: number;
  cursor?: string;
}) {
  const client = useAuthorizedClient();

  const params = new URLSearchParams({
    ...(limit && { limit: String(limit) }),
    ...(cursor && { cursor: String(cursor) }),
    order_by: '-purchase_date',
  });

  return useQuery(['purchases', { limit, cursor }], () =>
    client(`/v1/purchases/user?${params}`, {}).then(data => data)
  );
}

function useActiveTab() {
  const client = useAuthorizedClient();

  const params = new URLSearchParams({
    is_active: 'true',
    payment_model: 'pay_later',
    currency: 'USD',
  });

  return useQuery(['tabs', 'active'], () =>
    client(`/v1/tabs?${params}`, {}).then(data => data.data)
  );
}

function usePastTabs() {
  const client = useAuthorizedClient();

  const params = new URLSearchParams({
    status: 'closed',
  });

  return useQuery(['tabs', 'past'], () =>
    client(`/v1/tabs?${params}`, {}).then(data => data.data)
  );
}

export { usePurchases, useActiveTab, usePastTabs };
